import MicroModal from 'micromodal';

const $elements = {};

function setupElements() {
	$elements.shareTriggers = document.querySelectorAll('[data-micromodal-trigger="share-modal"]');
	$elements.shareModal = document.getElementById('share-modal');
	$elements.clipboardTrigger = document.getElementById('share-modal-clipboard');
}

function replaceShareModalLinks($triggers, $modal) {
	const $links = $modal.querySelectorAll('a.pkrd-btn');
	const $clipboardButton = $modal.querySelector('#share-modal-clipboard');

	$triggers.forEach(($trigger) => {
		$trigger.addEventListener('click', function () {
			const url = $trigger.dataset?.propertyUrl;

			if (!url) {
				return;
			}

			$links.forEach(($link) => {
				$link.href = $link.dataset.urlTemplate.replace('[URL]', url);
			});

			$clipboardButton.dataset.propertyUrl = url;
		});
	});

	$clipboardButton.addEventListener('click', function () {
		const url = $clipboardButton.dataset?.propertyUrl;

		if (! url) {
			return;
		}

		navigator.clipboard.writeText(url);
		alert(`Copied property link:\n ${url}`);
	});
}

function closeOnOverlayClick() {
	document.querySelectorAll('.modal__overlay').forEach(function(overlay) {
		overlay.addEventListener('click', function(event) {
			if (event.target === overlay) {
				MicroModal.close(overlay.parentNode.id);
			}
		})
	})
}

export default function modalInit() {
	setupElements();

	if ($elements.shareTriggers.length > 0 && !! $elements.shareModal) {
		replaceShareModalLinks($elements.shareTriggers, $elements.shareModal);
	}

	closeOnOverlayClick();

	MicroModal.init( {
		disableFocus: true,
		onShow: () => {
			window.dispatchEvent( new Event( 'resize' ) );
		},
	} );
};
